import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerFileds: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      padding: "0px 0px 0px 24px",
    },
    containerFiledItem: {
      display: "flex",
      flexDirection: "row",
    },
    titleItem: {
      maxWidth: "160px",
      minWidth: "160px",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    containerSwitchButtons: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
  };
});